import React from 'react';
import { translate } from 'react-i18next';
import numbro from 'numbro';
import { Icon, Segment, Header, Button, Modal, Message, Input, Divider } from 'semantic-ui-react';
import moment from 'moment';

import Utils from 'utils/Utils.js';
import {colors, fontSizes, fonts, shadow, shadowLight, spacings, layout, buttons} from 'style';

var style= {
    modal: {
        minWidth: '290px',
    },
    container: {
        textAlign: 'center',
    },
    addButton: {
        marginLeft: spacings.base,
        display: 'inline',
        width: '40px',
        height:'40px',
        padding:'0px',
    },
    addButtonIcon: {
        margin: '0px',
        color: '#fff',
        fontWeight: 'normal',
    },
	iconButton: {
		boxShadow: 'none',
		backgroundColor: 'transparent',
		border: 'none',
		fontSize: '24px',
		color: colors.themeBlue,
		width: '28px',
		height: '25px',
		paddingLeft: '0',
		paddingRight: '0',
		marginLeft: spacings.small,
		marginRight: spacings.small,
		position: 'relative',
		top: '4px',
	},
    dateSelect: {
        marginTop: '18px',
        fontSize: fontSizes.h4,
        color: colors.themeBlue,
    },
    dateSelectIcon: {
        cursor: 'pointer',
		marginLeft: '0',
		marginRight: '0',
    },
    body: {
        fontWeight: 'bold',
        fontSize: fontSizes.h1,
        lineHeight: '1',
        color: colors.themeBlue,
        paddingTop: spacings.large,
        paddingBottom: spacings.large,
    },
};

const StepsChallengeModal = ({t,
                              value,
                              startedAt,
                              challenge, 
                              selectedHistory,
                              cancelDoubleClick,
                              enableDateIncrease,
                              enableDateDecrease,
                              onChangeStartedAt,
                              onClose,
                              onChange,
                              onSubmit}) => (
    <Modal open 
           size='mini'
           closeIcon
           onClose={onClose}
           style={style.modal}>
        <Modal.Header>{t('Add Steps')}</Modal.Header>
        <Modal.Content>
            <div style={style.container}>
                <form onSubmit={onSubmit}>
                    <div style={style.dateSelect}>
                        <button style={style.iconButton} onDoubleClick={cancelDoubleClick} onClick={()=>enableDateDecrease && onChangeStartedAt(-1)} disabled={!enableDateDecrease}>
                            <Icon className="icon-chevron-left" style={style.dateSelectIcon}  disabled={!enableDateDecrease}/>
                        </button>
                        {moment(startedAt).format('ddd MMM DD')}
                        <button style={style.iconButton} onDoubleClick={cancelDoubleClick} onClick={()=>enableDateIncrease && onChangeStartedAt(1)} disabled={!enableDateIncrease}>
                            <Icon className="icon-chevron-right" style={style.dateSelectIcon} disabled={!enableDateIncrease}/>
                        </button>
                    </div>
                    <div style={style.body}>
                        {numbro(selectedHistory.actionsCompleted).format({trimMantissa: true, mantissa: 1, thousandSeparated: true})}
                    </div>

                    <Divider />

                    <Input value={value} onChange={onChange} type='number' placeholder={t('Add Steps')} />

                    <Button type='submit' style={style.addButton} circular color='teal'>
                        <Icon style={style.addButtonIcon} className='icon-plus'/>
                    </Button>
                </form>
            </div>
        </Modal.Content>
    </Modal>
);

export default translate('challenges')(StepsChallengeModal);



// WEBPACK FOOTER //
// ./src/modules/challenges/types/StepsChallengeModal.js